<template>
    <div>
        <center>
            <h4>TopUp Kuota</h4>
        </center>
        <br>
        <div v-if="step == 1">
            <form v-on:submit.prevent="nextStep" enctype="multipart/form-data">
                <label> Jumlah Kuota Respon (Rp 20 / Respon)</label>
                <money class="form-control" v-model="form.quota" v-bind="money"></money>
                <br>
                <i>Minimal transaksi 5.000 Respon (Rp 100.000)</i>
                <br>
                <hr>
                <div class="float-right">
                    <table style="border: none;">
                        <tr>
                            <td>Total Harga</td>
                            <td>&nbsp;:&nbsp;</td>
                            <td><b>{{ formatRupiah(totalPrice) }}</b></td>
                        </tr>
                    </table>
                    <br>
                </div>
                <br>
                <button v-if="form.quota >= 5000" class="btn btn-success btn-block">Beli</button>
                <button v-else class="btn btn-danger btn-block" disabled>Belum Mencapai Minimal Pembelian (Rp 100.000)</button>
            </form>
        </div>
        <div v-else>
            <div>
                <table style="border: none;">
                    <tr>
                        <td>Total Harga</td>
                        <td>&nbsp;:&nbsp;</td>
                        <td><b>{{ formatRupiah(totalPrice) }}</b></td>
                    </tr>
                </table>
            </div>
            <hr>

            <div v-if="topupBlocked" class="alert alert-danger">
                <i class="fas fa-ban"></i> <strong>Top Up Diblokir</strong>
                <p class="mb-0 mt-1" style="font-size:13px">{{ topupBlockedReason }}</p>
            </div>

            <!-- StarQRIS QR Modal -->
            <div v-if="showStarQrisModal" class="sq-modal-backdrop">
                <div class="sq-modal-content">
                    <div class="sq-modal-header">
                        <i class="fas fa-qrcode text-primary"></i>
                        <h5 class="mb-0 ml-2">Bayar via StarQRIS</h5>
                    </div>
                    <div class="sq-modal-body">
                        <StarQrisPayment
                            :transactionId="starqrisTransactionId"
                            :data="starqrisPayment"
                            @paid="onStarQrisPaid"
                            @done="onStarQrisDone"
                            @cancel="closeStarQrisModal"
                        />
                    </div>
                </div>
            </div>

            <!-- Manual transfer -->
            <div v-if="showManualForm">
                <ManualTransferForm
                    paymentMode="topup_chatgpt"
                    :amount="totalPrice"
                    :targetId="parseInt(id)"
                    :targetLabel="'Top Up Kuota AI Sharing (' + formatResponseQuota(form.quota) + ' Respon)'"
                    @cancel="showManualForm = false"
                    @success="onManualSuccess"
                />
            </div>

            <div v-else-if="!showStarQrisModal">
                <div v-if="!isLoading">
                    <div class="col-12 p-0" v-if="paymentMethods.starqris_enabled" style="margin-bottom:12px">
                        <button type="button" class="ch-card starqris-card" style="--accent:#00b894;width:100%"
                            @click="buy('starqris')" :disabled="!canPay">
                            <span class="ch-logo no-img"><i class="fas fa-qrcode"></i></span>
                            <span class="ch-name">QRIS via StarQRIS</span>
                            <span class="ch-desc">Scan QR, bayar otomatis</span>
                            <i class="fas fa-chevron-right ch-arrow"></i>
                        </button>
                    </div>

                    <div class="col-12 p-0" v-if="paymentMethods.tripay_enabled">
                        <div v-for="grp in groupedChannels" :key="grp.group" class="ch-group">
                            <div class="ch-group-title">{{ grp.group }}</div>
                            <div class="ch-grid">
                                <button v-for="ch in grp.items" :key="ch.channel_code" type="button"
                                    class="ch-card" :style="'--accent:' + (ch.class || '#5F63F2')"
                                    @click="buy(ch.channel_code)" :disabled="!canPay">
                                    <span class="ch-logo" :class="{ 'no-img': imgErr[ch.channel_code] }">
                                        <img :src="channelIcon(ch.channel_code)" :alt="ch.channel_name" @error="onImgError(ch.channel_code)">
                                        <i class="fas fa-university"></i>
                                    </span>
                                    <span class="ch-name">{{ ch.channel_name }}</span>
                                    <i class="fas fa-chevron-right ch-arrow"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div v-if="!paymentMethods.tripay_enabled && !paymentMethods.manual_transfer_enabled && !paymentMethods.starqris_enabled" class="alert alert-warning">
                        Tidak ada metode pembayaran tersedia saat ini. Silakan hubungi admin.
                    </div>

                    <div v-if="paymentMethods.manual_transfer_enabled" style="margin-top:10px">
                        <button class="btn btn-block btn-warning" @click="openManualTransfer" :disabled="!canPay">
                            <i class="fas fa-university"></i> Bayar via Transfer Manual
                        </button>
                        <small class="text-muted d-block mt-1 text-center">
                            Transfer ke rekening admin → upload bukti → admin verify
                        </small>
                    </div>

                    <div style="margin-top:10px">
                        <button class="btn-topup btn btn-block text-white" style="background-color:#3786c5"
                            @click="buy('saldo')" :disabled="!canPay">
                            Saldo Akun ({{ formatRupiah(user_balance) }})
                        </button>
                    </div>
                </div>
                <div v-else class="text-center py-3">
                    <div class="spinner-border spinner" role="status"></div>
                    Loading...
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Money } from 'v-money'
import axios from 'axios'
import ManualTransferForm from '@/components/forms/billing/ManualTransferForm.vue'
import StarQrisPayment from '@/components/forms/billing/StarQrisPayment.vue'

export default {
    props: ['id', 'dataset_id'],
    components: {
        Money,
        ManualTransferForm,
        StarQrisPayment,
    },
    data() {
        return {
            step: 1,
            form: {
                quota: null,
            },
            money: {
                thousands: '.',
                precision: 0,
            },
            user_balance: 0,
            payment_channel: [],
            imgErr: {},
            isLoading: false,
            paymentMethods: { tripay_enabled: true, manual_transfer_enabled: false, starqris_enabled: false, banks: [] },
            showStarQrisModal: false,
            starqrisPayment: {},
            starqrisTransactionId: '',
            showManualForm: false,
            topupBlocked: false,
            topupBlockedReason: '',
        }
    },
    computed: {
        totalPrice() {
            return (parseInt(this.form.quota) || 0) * 20
        },
        canPay() {
            return this.form.quota >= 5000 && !this.topupBlocked && !this.isLoading
        },
        groupedChannels() {
            const groups = {}
            ;(this.payment_channel || []).forEach(ch => {
                const g = ch.group || 'Lainnya'
                ;(groups[g] = groups[g] || []).push(ch)
            })
            const order = ['Virtual Account', 'E-Wallet', 'Convenience Store']
            const rank = (x) => (order.indexOf(x) < 0 ? 99 : order.indexOf(x))
            return Object.keys(groups)
                .sort((a, b) => rank(a) - rank(b))
                .map(g => ({ group: this.groupLabel(g), items: groups[g] }))
        },
    },
    beforeDestroy() {
        this.$root.$off('toggle_modal', this.fnToggleModal)
    },
    mounted() {
        this.fnToggleModal = (param) => {
            this.toggleModal(param)
        }
        this.$root.$on('toggle_modal', this.fnToggleModal)
        this.fetchUser()
        this.fetchPaymentChannel()
        this.fetchPaymentMethods()
    },
    methods: {
        formatResponseQuota(quota) {
            const n = parseInt(quota) || 0
            return n.toLocaleString('id-ID')
        },
        channelIcon(code) {
            const map = {
                PERMATAVA: 'https://assets.tripay.co.id/upload/payment-icon/szezRhAALB1583408731.png',
                BNIVA: 'https://assets.tripay.co.id/upload/payment-icon/n22Qsh8jMa1583433577.png',
                BRIVA: 'https://assets.tripay.co.id/upload/payment-icon/8WQ3APST5s1579461828.png',
                MANDIRIVA: 'https://assets.tripay.co.id/upload/payment-icon/T9Z012UE331583531536.png',
                BCAVA: 'https://assets.tripay.co.id/upload/payment-icon/ytBKvaleGy1605201833.png',
                MUAMALATVA: 'https://assets.tripay.co.id/upload/payment-icon/GGwwcgdYaG1611929720.png',
                CIMBVA: 'https://assets.tripay.co.id/upload/payment-icon/WtEJwfuphn1614003973.png',
                BSIVA: 'https://assets.tripay.co.id/upload/payment-icon/tEclz5Assb1643375216.png',
                DANAMONVA: 'https://assets.tripay.co.id/upload/payment-icon/F3pGzDOLUz1644245546.png',
                ALFAMART: 'https://assets.tripay.co.id/upload/payment-icon/jiGZMKp2RD1583433506.png',
                INDOMARET: 'https://assets.tripay.co.id/upload/payment-icon/zNzuO5AuLw1583513974.png',
                ALFAMIDI: 'https://assets.tripay.co.id/upload/payment-icon/aQTdaUC2GO1593660384.png',
                QRIS: 'https://assets.tripay.co.id/upload/payment-icon/BpE4BPVyIw1605597490.png',
                QRIS2: 'https://assets.tripay.co.id/upload/payment-icon/8ewGzP6SWe1649667701.png',
            }
            return map[code] || ''
        },
        groupLabel(g) {
            return ({
                'Virtual Account': 'Transfer Bank (Virtual Account)',
                'E-Wallet': 'QRIS / E-Wallet',
                'Convenience Store': 'Minimarket / Retail',
            })[g] || g
        },
        onImgError(code) {
            this.$set(this.imgErr, code, true)
        },
        async fetchPaymentChannel() {
            try {
                const payment_channel = await this.$store.dispatch('payment_channel')
                this.payment_channel = payment_channel.data.data.payment_channel || []
            } catch (err) {
                this.$toast.error(err.response.data.message)
            }
        },
        async fetchPaymentMethods() {
            try {
                const r = await axios.get('payment/methods')
                if (r.data && r.data.success) {
                    this.paymentMethods = r.data.data
                    this.topupBlocked = !!(r.data.data && r.data.data.topup_blocked)
                    this.topupBlockedReason = (r.data.data && r.data.data.topup_blocked_reason) || ''
                }
            } catch (err) {
                // fallback: tripay only
            }
        },
        toggleModal(param) {
            this.$modal.toggle(param)
        },
        nextStep() {
            if (this.form.quota < 5000) {
                this.$toast.error('Minimal pembelian 5.000 Respon (Rp 100.000)')
                return
            }
            this.step = 2
        },
        openManualTransfer() {
            if (this.form.quota < 5000) {
                this.$toast.error('Minimal pembelian 5.000 Respon (Rp 100.000)')
                return
            }
            this.showManualForm = true
        },
        onManualSuccess() {
            this.showManualForm = false
            this.$root.$emit('toggle_modal', 'topup')
            this.$root.$emit('refresh_quota', true)
            this.$router.push('/billing/manual-payments')
        },
        async buy(channel_code) {
            if (this.form.quota < 5000) {
                this.$toast.error('Minimal pembelian 5.000 Respon (Rp 100.000)')
                return
            }
            this.isLoading = true
            try {
                const create = await this.$store.dispatch('chatgpt_topup', {
                    chatgpt_id: this.id,
                    quota: parseInt(this.form.quota),
                    channel_code,
                })

                if (channel_code === 'starqris' && create.data.data && create.data.data.starqris) {
                    this.starqrisTransactionId = create.data.data.transaction.transaction_id
                    this.starqrisPayment = create.data.data.starqris
                    this.showStarQrisModal = true
                    this.isLoading = false
                    return
                }

                if (create?.data?.data?.transaction?.checkout_url) {
                    window.location.replace(create.data.data.transaction.checkout_url)
                    return
                }

                this.$root.$emit('toggle_modal', 'topup')
                this.$toast.success(create.data.message)
                this.$root.$emit('refresh_quota', true)
            } catch (err) {
                this.$toast.error(err.response && err.response.data ? err.response.data.message : 'Gagal top up')
            } finally {
                this.isLoading = false
            }
        },
        closeStarQrisModal() {
            this.showStarQrisModal = false
            this.starqrisPayment = {}
            this.starqrisTransactionId = ''
        },
        onStarQrisPaid() {
            this.$toast.success('Pembayaran berhasil! Kuota AI telah ditambahkan.')
        },
        onStarQrisDone() {
            this.closeStarQrisModal()
            this.$root.$emit('toggle_modal', 'topup')
            this.$root.$emit('refresh_quota', true)
        },
        formatRupiah(numb) {
            const n = parseInt(numb) || 0
            return 'Rp ' + n.toLocaleString('id-ID')
        },
        async fetchUser() {
            try {
                const user_data = await this.$store.dispatch('user_detail')
                this.user_balance = user_data.data.data.user.balance
            } catch (err) {
                this.$toast.error(err.response.data.message)
            }
        },
    },
}
</script>

<style scoped>
table {
    border: 1px solid;
}

.sq-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 11000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
}
.sq-modal-content {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
    max-width: 420px;
    width: 100%;
    overflow: hidden;
}
.sq-modal-header {
    display: flex;
    align-items: center;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid #e9ecef;
}
.sq-modal-body {
    padding: 1rem;
}

.ch-group { margin-bottom: 18px; }
.ch-group-title {
    font-size: 11.5px; font-weight: 700; letter-spacing: .05em; text-transform: uppercase;
    color: #8b93a7; margin: 0 2px 9px;
}
.ch-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
@media (max-width: 576px) { .ch-grid { grid-template-columns: 1fr; } }
.ch-card {
    display: flex; align-items: center; gap: 12px; width: 100%; text-align: left;
    background: #fff; border: 1.5px solid #e9ebf6; border-radius: 12px; padding: 11px 14px;
    cursor: pointer; transition: all .18s ease; position: relative; overflow: hidden;
}
.ch-card::before {
    content: ''; position: absolute; left: 0; top: 0; bottom: 0; width: 4px;
    background: var(--accent, #5F63F2); opacity: 0; transition: opacity .18s;
}
.ch-card:hover:not(:disabled) {
    border-color: var(--accent, #5F63F2);
    box-shadow: 0 9px 24px -12px rgba(95, 99, 242, .5); transform: translateY(-2px);
}
.ch-card:hover:not(:disabled)::before { opacity: 1; }
.ch-card:disabled { opacity: .5; cursor: not-allowed; }
.ch-logo {
    flex: 0 0 auto; width: 56px; height: 36px; display: flex; align-items: center;
    justify-content: center; background: #f6f7fc; border: 1px solid #eef0f8; border-radius: 8px;
}
.ch-logo img { max-width: 46px; max-height: 26px; object-fit: contain; }
.ch-logo i { display: none; color: var(--accent, #5F63F2); font-size: 18px; }
.ch-logo.no-img img { display: none; }
.ch-logo.no-img i { display: inline-block; }
.ch-name { flex: 1 1 auto; font-weight: 600; font-size: 13.5px; color: #2b3042; line-height: 1.25; }
.ch-desc { display: block; font-size: 11px; font-weight: 400; color: #8b93a7; margin-top: 2px; }
.starqris-card .ch-name { display: flex; flex-direction: column; }
.ch-arrow { flex: 0 0 auto; color: #c3c8da; font-size: 13px; transition: .18s; }
.ch-card:hover:not(:disabled) .ch-arrow { color: var(--accent, #5F63F2); transform: translateX(2px); }
</style>
